import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { FarmerDetails } from '../models/farmer-details.model';
import { BaseService } from './common/base.service';
import { TokenService } from './common/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService extends BaseService {

  constructor(private _http: HttpClient, tokenService: TokenService) { super(tokenService); }

  getOTP(phonno: any) {
    return this._http.post<any>(`${environment.apiUrl}Login/GetOTP`, phonno)
  }

  validateOTP(body: any) {
    return this._http.post(environment.apiUrl + 'Auth/ValidOtpToken', body)
  }
  // validateOTP(credentials: any){
  //   return this._http.post(environment.apiUrl + 'Auth/ValidOtpToken', credentials)
  // }

  login(username: string, password: string) {
    return this._http
      .post<any>(`${environment.apiUrl}auth/login`, { username, password })
      .pipe(
        map(user => {
          window.sessionStorage.setItem("token", JSON.stringify(user));
          this.tokenService.authenticate(user);
          return user;
        })
      );
  }

  // getInitialToken() {
  //   return this._http.get(environment.apiUrl + 'Auth/GetToken')
  // }

  getInitialToken() {
    return this._http.post<any>(environment.apiUrl + 'Auth/GetToken', {})
  }

  getOTPforUsers(userName: any) {
    return this._http.get(environment.apiUrl + 'Login/GetOtpForUser?UserName=' + userName)
  }

  changePasswordForUser(userName, passWord, otp) {
    return this._http
      .post<any>(`${environment.apiUrl}Login/ForgotPassword`, { userName, passWord, otp });
  }

  activityDataTimeRecord(reqBody) {
    return this._http.post<any>(`${environment.apiUrl}Login/InsertUserActivityTracker`, reqBody);
  }
}
